import { connect } from 'react-redux'
import datePickerSelector from './datePickerSelector'
import DatePicker from './DatePicker'

export default connect(
  datePickerSelector,
  {}
)(DatePicker)
